<template>
    <div class="app-container">
        
        <div class="user-realname">
            <h2>{{dataList.user.realname}}</h2>
            <el-button type="warning" plain @click.native="resetPass()" style="width:100px">重设密码</el-button>
        </div>
        
        <h3>个人信息</h3>
        <div class="user-info">
            <el-row>
                <el-col :span="2"><div class="grid-content">用户名id：</div></el-col>
                <el-col :span="22"><div class="grid-content">{{dataList.user.id}}</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="2"><div class="grid-content">手机号：</div></el-col>
                <el-col :span="22"><div class="grid-content">{{dataList.user.tel}}</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="2"><div class="grid-content">身份证号：</div></el-col>
                <el-col :span="22"><div class="grid-content">{{dataList.user.idcard}}</div></el-col>
            </el-row>
        </div>

        <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" />
        
        <div class="user-project-list">
            <h3>关联设备列表</h3>
            <div class="user-project-list-itme clearfix">
                <div v-for="(item, index) in dataList.equipment" :key="index">
                    <div class="upl-itme">
                        <div class="upl-itme-img" @click="routerPushSD(item.id)">
                            <svg viewBox="0 0 36 36" width="200" height="200" xmlns="http://www.w3.org/2000/svg"><g :stroke="item.is_internet == '未连接' || item.is_internet == '模块不在线' ? '#8E989C' : '#409EFF'" fill="none" fill-rule="evenodd"><rect stroke-width="1.7" x=".9" y="3.4" width="34.3" height="29.1" rx="6"/><path d="m20.5 13 1.7 1.8v4.8c0 2.3-1.9 4.3-4.2 4.3-2.3 0-4.2-2-4.2-4.3v-4.8l1.6-1.7.7.7-1.3 1.4v4.4c0 1.7 1.4 3.2 3.2 3.2 1.7 0 3.2-1.5 3.2-3.2v-4.4l-1.4-1.4.7-.7Zm3.3 6.6c0 3.2-2.6 5.9-5.8 5.9a5.9 5.9 0 0 1-5.8-6v-4.8l3-3 2 2.2-1.1 1v4.8c0 1 .8 2 1.8 2s1.9-1 1.9-2v-5h-1v5c0 .5-.4.9-.9.9a.8.8 0 0 1-.8-.9v-4.3l3.7-3.6 3 3v4.8Zm-5.9-7.7.7.6-.7.6-.6-.6.6-.6Zm3-1.6-1.6 1.5-1.4-1.4-1.3 1.4-1.4-1.5-4 4v5.3c0 3.8 3 7 6.8 7a7 7 0 0 0 6.9-7v-5.3l-4-4Z" stroke-width=".5" :fill="item.is_internet == '未连接' || item.is_internet == '模块不在线' ? '#8E989C' : '#409EFF'"/><g stroke-linecap="round" stroke-width="1.3"><path d="m30 8.6 2.1 2M30 12l2.1 2.2M30 15.5l2.1 2M30 18.9l2.1 2M30 22.3l2.1 2.2M30 25.7l2.1 2.2"/></g><g stroke-linecap="round" stroke-width="1.3"><path d="m3.4 8.6 2.1 2M3.4 12l2.1 2.2M3.4 15.5l2.1 2M3.4 18.9l2.1 2M3.4 22.3l2.1 2.2M3.4 25.7l2.1 2.2"/></g></g></svg>
                        </div>
                        <div class="upl-itme-id">
                            <div class="upli-label">设备id</div>
                            <div>{{item.device_id}}</div>
                        </div>
                        <div class="upl-itme-name">
                            <div class="upli-label">位置</div>
                            <div>{{item.eq_name}}</div>
                        </div>
                        <div class="upl-itme-internet">
                            <div class="upli-label">设备状态</div>
                            <div>{{item.is_internet}}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 登录密码重置 -->
        <el-dialog title="登录密码重置" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
            <span>您将进行重置密码操作，重置后原登录密码将不可用，新登录密码为“123456”</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="resetPassTuserItme">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {apiSUserdetails} from "../../api/views/sale";
import {apiResetPassword} from "../../api/views/maintain";

export default {
    components: {},
    data() {
        return {
            query:{
                id: "",
            },
            dialogVisible:false,
            dataList: [],
        }
    },
    mounted() {

    },
    created:function() {
        if(this.$route.query.id){
            this.βgetApp.globalData = {saleID:this.$route.query.id}
            this.getList(this.$route.query.id)
        }else{
            this.getList(this.βgetApp.globalData.saleID)
        }
    },
    methods: {
        getList(query){
            const that = this
            apiSUserdetails({id:query}).then(res => {
                console.log(res)
                that.dataList = res
                console.log(that.dataList)
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        resetPass(){
            this.handleClose()
            this.resetPassTuserItmeId = this.$route.query.id
        },
        resetPassTuserItme(){
            // console.log(this.resetPassTuserItmeId)
            let data = {id:this.resetPassTuserItmeId}
            apiResetPassword(data).then(res => {
            console.log(data)
                if (res.code == 0) {
                    this.$message({
                        message: res.message,
                        type: "success"
                    });
                    // 刷新列表
                    this.getList(this.$route.query.id)
                    this.handleClose()
                }else{
                    this.$message({
                        message: res.message,
                        type: "error"
                    })
                }
            })
        },
        handleClose(done) {
            this.dialogVisible = !this.dialogVisible
        },
        routerPushSD(row){
            console.log(row)
            this.$router.push({path:'../equipment-details',query:{id:row}});
        },
    }
};
</script>


<style lang="scss" scoped>

  .app-container{
    color: #1f2f3d;
  }
  .app-container h2{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 28px;
  }
  .app-container h3{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 22px;
  }
  .user-realname h2{
      display: inline-block;
      margin-right: 20px;
      vertical-align: sub;
  }
  .user-info{
      margin-bottom: 50px;
  }
  .user-info .el-row{
      margin: 10px;
      font-size: 14px;
  }
  .user-project-list-itme{
    width: 95%;
    margin: 0 auto;
    .upl-itme {
        float: left;
        width: 33%;
        .upl-itme-img{
            text-align: center;
            svg{
                width: 90%;
            }
        }
        .upl-itme-switch{
        display: flex;
        justify-content: space-between;
        align-items: center;
        }
        .upli-label{
            width: 80px;
            color: rgba(0, 0, 0, .6);
        }
    }
  }
  
  .upl-itme > div {
      width: 200px;
      margin: 20px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
  }
</style>